﻿function kendoLessThanDateRule(input) {
    if (input.val() !== "") {
        if (input.data().role === 'datepicker') {
            var picker = input.data("kendoDatePicker");
            return picker.min() < kendo.parseDate(picker.element.val());
        }
    }

    return true;
}

function kendoGreaterThanDateRule(input) {
    if (input.val() !== "") {
        if (input.data().role === 'datepicker') {
            if (input.is("[data-val-greaterthandate]")) {
                var date = kendo.parseDate(input.val()),
                    datetocheckagainst = kendo.parseDate($("[name='" + input.attr("data-val-greaterthandate-datetocheckagainst") + "']").val());

                return !date || !datetocheckagainst || datetocheckagainst.getTime() >= date.getTime();
            }

            var picker = input.data("kendoDatePicker");
            return picker.max() > kendo.parseDate(picker.element.val());
        }
    }

    return true;
}

function kendoMvcDateRule(input) {
    var datarole = $(input).data('role');
    if (datarole === 'datepicker') {
        var value = $(input).val();
        var date = kendo.parseDate(value);
        if (value && !date) {
            return false;
        }
    }
    return true;
}

$(function() {
    $("form").kendoValidator({
        rules: {
            lessThanDate: function(input) {
                return kendoLessThanDateRule(input);
            },
            greaterThanDate: function(input) {
                return kendoGreaterThanDateRule(input);
            },
            mvcdate: function(input) {
                return kendoMvcDateRule(input);
            }
        },
        messages: {
            lessThanDate: function(input) {
                if (input.data().role === 'datepicker') {
                    var picker = input.data("kendoDatePicker");
                    return "Datum moet groter zijn dan: " + picker.min().toLocaleDateString();
                }
            },
            greaterThanDate: function (input) {
                if (input.data().role === 'datepicker') {
                    if (input.is("[data-val-greaterthandate]")) {
                        return input.attr("data-val-greaterthandate");
                    }

                    var picker = input.data("kendoDatePicker");
                    return "Datum moet kleiner zijn dan: " + picker.max().toLocaleDateString();
                }
            },
            mvcdate: function(input) {
                return input.attr("data-val-validdatetime");
            },
        }
    });
});